import Vue from 'vue'
import axios from 'axios'
import store from '../store/store'
import router from '../router'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_KPIS_URL}/api/v1/kpis/`
})

instance.interceptors.request.use(
  async (config) => {
    Vue.prototype.$Progress.start()
    store.commit('loader/addRequest')

    if (Vue.prototype.$auth.isAuthenticated()) {
      config.headers.Authorization = [
        Vue.prototype.$auth.options.tokenType,
        Vue.prototype.$auth.getToken()
      ].join(' ')
    } else {
      delete config.headers.Authorization
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response) => {
    store.commit('loader/subtractRequest')
    if (!store.getters['loader/isAxiosLoading']) {
      Vue.prototype.$Progress.finish()
    }

    return response
  },
  (error) => {
    if (error instanceof axios.Cancel) {
      router.push({ name: 'root' }).catch(() => {})
    }

    store.commit('loader/subtractRequest')
    if (!store.getters['loader/isAxiosLoading']) {
      Vue.prototype.$Progress.fail()
    }

    if (error.response && error.response.status === 401) {
      router.push({ name: 'logout' }).catch(() => {})
    }

    if (error.response && error.response.status === 403) {
      Vue.prototype.$message.error('No tienes acceso a esta cuenta')
      router.push({ name: 'root' }).catch(() => {})
    }

    return Promise.reject(error)
  }
)

export default {
  install(Vue) {
    Vue.request_kpis = instance
  }
}
